export default __webpack_public_path__ + "static/media/ic_combined.473ffc35.png";